import React from 'react';
//import ChartViewComponent from '../components/chartView';
import ChartConfigComponent from '../../components/ChartConfig/chartConfig'

class ChartConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chartConfig: [],
            types: [],
            data: [],
            parameters: null,
            selectedCategory: {
                'category': null
            },
            selectedOptions: {},
        };
        this.handleClickCategory = this.handleClickCategory.bind(this);
        this.handleClickOption = this.handleClickOption.bind(this);
        this.handleChangeCategory = this.handleChangeCategory.bind(this);
        this.handleChangeOption = this.handleChangeOption.bind(this);
    }

    componentDidMount() {
        const {
            chartConfig
        } = this.props;

        this.setState({ chartConfig: chartConfig })
    }

    /**
     * Función que asigna tipo de gráfico seleccionado y sus opciones disponibles.
     * @param {Event} e - Evento que se desencadena al hacer clic sobre un tipo de gráfico.
    */
    handleClickCategory(e) {
        const selected = e.currentTarget.value;
        const { selectedCategory, selectedOptions } = this.state;
        const { setChartConfiguration } = this.props;
        if (selectedCategory.category === selected) {
            selectedCategory.category = null;
            this.setState({ parameters: null });
        }
        else {
            selectedCategory.category=selected;
            this.setParameters(selected);
        }
        this.setState({ selectedCategory:selectedCategory })
        setChartConfiguration(selectedCategory);
    }

    /**
     * Función que asigna tipo de gráfico seleccionado y sus opciones disponibles.
     * @param {Event} e - Evento que se desencadena al hacer clic sobre un tipo de gráfico.
    */
   
    handleChangeCategory(e) {
        
        const selected = e.target.value;
        const { selectedCategory, selectedOptions } = this.state;
        const { setChartConfiguration } = this.props;
        
        selectedCategory.category=selected;
        this.setParameters(selected);
        
        this.setState({ selectedCategory:selectedCategory })
        setChartConfiguration(selectedCategory);
        
    }

    /**
     * Función que asigna opciones seleccionadas
     * @param {Event} e - Evento que se desencadena al hacer clic sobre una opción.
    */
    handleClickOption(e) {
        const { setChartConfiguration } = this.props;
        const parameter = e.currentTarget.id;
        const option = e.currentTarget.value;
        const { selectedOptions } = this.state;
        if (selectedOptions.options[parameter] === option){
            delete selectedOptions.options[parameter];
        }
        else{
            selectedOptions.options[parameter] = option;
        }
       
        this.setState({ selectedOptions: selectedOptions })
        setChartConfiguration(selectedOptions);
    }

    /**
     * Función que asigna opciones seleccionadas
     * @param {Event} e - Evento que se desencadena al hacer clic sobre una opción.
    */
    handleChangeOption(e) {
        const { setChartConfiguration } = this.props;
        const value = JSON.parse(e.target.value);
        const parameter = value.parameterId;
        const option = value.optionId;
        const { selectedOptions } = this.state;
        selectedOptions.options[parameter] = option;    
        this.setState({ selectedOptions: selectedOptions })
        setChartConfiguration(selectedOptions);
    }

    /**
     * Función que asigna opciones disponibles para un tipo de gráfico seleccionado.
     * @param {String} id - Identificador de tipo de gráfico.
    */
    setParameters(id) {
        var {
            chartConfig,
            selectedOptions
        } = this.state;
        const {
            setChartConfiguration
        } = this.props;
        var parameters = [];
        var parameters = []
        chartConfig.map((category) => {
            if (category.id === id) {
                parameters = category.parameters;
            }
        })
        if (parameters.length !== 0) {
            this.setState({ parameters: parameters });
            this.setState({selectedOptions:selectedOptions})
        }
        else {
            this.setState({ parameters: null })
            this.setState({selectedOptions:selectedOptions})
        }
        selectedOptions['options']={}
        setChartConfiguration(selectedOptions);
    }

    render() {
        const {
            chartConfig,
            parameters,
            selectedCategory,
            selectedOptions
        } = this.state;
        //console.log(selectedOptions)

        return (
            <ChartConfigComponent
                handleClickCategory={this.handleClickCategory}
                handleChangeCategory={this.handleChangeCategory}
                handleClickOption={this.handleClickOption}
                handleChangeOption={this.handleChangeOption}
                chartConfig={chartConfig}
                selectedCategory={selectedCategory}
                selectedOptions={selectedOptions}
                parameters={parameters}
            />
        )
    }
}


export default ChartConfig;